import { BaseMediaApiModel } from '@era/inroom-sdk';

import { Action } from '@ngrx/store';

export enum TvChannelsActionTypes {
  LOAD_TV_CHANNELS = '[TV] Load channels',
}

export class LoadTvChannels implements Action {
  readonly type = TvChannelsActionTypes.LOAD_TV_CHANNELS;

  constructor(public payload: BaseMediaApiModel[]) {}
}

export type TvChannelsActionsUnion = LoadTvChannels;
